module.exports = {"TXTINS_Next":{"id":"TXTINS_Next","defaultMessage":"Következő","track":"Next"}}